import type { IElementConfig } from '../../utils/element/types';
import type { TypeElements } from '../../types/element';

import { merge } from '../../helper';

import appendChildren from '../../general/append/appendChildren';
import isObject from '../../general/isObject';
import prependChild from '../../general/prepend/prependChild';
import prependChildren from '../../general/prepend/prependChildren';

import * as exElement from '../../utils/element';

import * as exInput from './create';

// ----------------------------------------------------------------------------

export interface IInputGroupConfig extends IElementConfig {
    prepend?: TypeElements | Record<string, any>;
    element?: TypeElements | Record<string, any>;
    input?: TypeElements | Record<string, any>;
    append?: TypeElements | Record<string, any>;
}

// ----------------------------------------------------------------------------

function create(config: IInputGroupConfig = {}): Record<string, any> {
    // Default Config
    const defConfig: IInputGroupConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (input group)
    const elInputGroup = exElement.create({
        merge: defConfig,
        class: {
            new: 'input-group',
        },
    });
    elements.element = elInputGroup;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: IInputGroupConfig = {}): void {
    // Is using prepend
    if (config.prepend != null) {
        //
        if (isObject(config.prepend)) {
            // Create element (span)
            const elSpan = exElement.create({
                merge: config.prepend,
                tag: 'span',
                class: {
                    new: 'input-group-text',
                },
            });
            prependChild(elements.element, elSpan);
            elements.span = elSpan;
        }
        //
        else {
            const arr = Array.isArray(config.prepend) ? config.prepend : [config.prepend];
            prependChildren(elements.element, arr);
        }
    }

    // ------------------------------------------------------------------------

    // If using element
    if (config.element != null) {
        const arr = Array.isArray(config.element) ? config.element : [config.element];
        appendChildren(elements.element, arr);
    }

    // If using input
    if (config.input != null) {
        //
        if (isObject(config.input)) {
            // Create element (input)
            const input = exInput.create({
                merge: config.input,
            });
            elements.element.appendChild(input.element);
            elements.input = input;
        }
        //
        else {
            const arr = Array.isArray(config.input) ? config.input : [config.input];
            appendChildren(elements.element, arr);
        }
    }

    // ------------------------------------------------------------------------

    // If using append
    if (config.append != null) {
        //
        if (isObject(config.append)) {
            // Create element (span)
            const elSpan = exElement.create({
                merge: config.append,
                tag: 'span',
                class: {
                    new: 'input-group-text',
                },
            });
            elements.element.appendChild(elSpan);
            elements.span = elSpan;
        }
        //
        else {
            const arr = Array.isArray(config.append) ? config.append : [config.append];
            appendChildren(elements.element, arr);
        }
    }
}

// ----------------------------------------------------------------------------

export { create };
